package com.kinoshazam.uiKit.theme.colors

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.graphics.Color

class UiKitColors(
    color_1: Color,
    color_2: Color,
    color_3: Color,
    color_4: Color,
    color_5: Color,
    color_6: Color,
    color_7: Color,
    color_8: Color,
    color_9: Color,
    color_10: Color,
    color_11: Color,
    color_12: Color,
    color_13: Color,
    color_14: Color,
    color_15: Color,
    color_16: Color,
    color_17: Color,
    color_18: Color,
    color_19: Color,
    color_20: Color,
    color_21: Color,
    color_22: Color,
    color_23: Color,
    color_24: Color,
    color_25: Color,
    colorOther_1: Color,
    colorOther_2: Color,
    colorOther_3: Color,
    colorOther_4: Color,
    colorOther_5: Color,
    colorOther_6: Color,
    colorOther_7: Color,
    colorOther_8: Color,
    error: Color,
    transparent: Color,
    color_3_50: Color,
    color_3_80: Color,
) {

    var color_1 by mutableStateOf(color_1)
        private set
    var color_2 by mutableStateOf(color_2)
        private set
    var color_3 by mutableStateOf(color_3)
        private set
    var color_4 by mutableStateOf(color_4)
        private set
    var color_5 by mutableStateOf(color_5)
        private set
    var color_6 by mutableStateOf(color_6)
        private set
    var color_7 by mutableStateOf(color_7)
        private set
    var color_8 by mutableStateOf(color_8)
        private set
    var color_9 by mutableStateOf(color_9)
        private set
    var color_10 by mutableStateOf(color_10)
        private set
    var color_11 by mutableStateOf(color_11)
        private set
    var color_12 by mutableStateOf(color_12)
        private set
    var color_13 by mutableStateOf(color_13)
        private set
    var color_14 by mutableStateOf(color_14)
        private set
    var color_15 by mutableStateOf(color_15)
        private set
    var color_16 by mutableStateOf(color_16)
        private set
    var color_17 by mutableStateOf(color_17)
        private set
    var color_18 by mutableStateOf(color_18)
        private set
    var color_19 by mutableStateOf(color_19)
        private set
    var color_20 by mutableStateOf(color_20)
        private set
    var color_21 by mutableStateOf(color_21)
        private set
    var color_22 by mutableStateOf(color_22)
        private set
    var color_23 by mutableStateOf(color_23)
        private set
    var color_24 by mutableStateOf(color_24)
        private set
    var color_25 by mutableStateOf(color_25)
        private set
    var colorOther_1 by mutableStateOf(colorOther_1)
        private set
    var colorOther_2 by mutableStateOf(colorOther_2)
        private set
    var colorOther_3 by mutableStateOf(colorOther_3)
        private set
    var colorOther_4 by mutableStateOf(colorOther_4)
        private set
    var colorOther_5 by mutableStateOf(colorOther_5)
        private set
    var colorOther_6 by mutableStateOf(colorOther_6)
        private set
    var colorOther_7 by mutableStateOf(colorOther_7)
        private set
    var colorOther_8 by mutableStateOf(colorOther_8)
        private set
    var error by mutableStateOf(error)
        private set
    var transparent by mutableStateOf(transparent)
        private set
    var color_3_50 by mutableStateOf(color_3_50)
        private set
    var color_3_80 by mutableStateOf(color_3_80)
        private set


    fun update(colors: UiKitColors) {
        color_1 = colors.color_1
        color_2 = colors.color_2
        color_3 = colors.color_3
        color_4 = colors.color_4
        color_5 = colors.color_5
        color_6 = colors.color_6
        color_7 = colors.color_7
        color_8 = colors.color_8
        color_9 = colors.color_9
        color_10 = colors.color_10
        color_11 = colors.color_11
        color_12 = colors.color_12
        color_13 = colors.color_13
        color_14 = colors.color_14
        color_15 = colors.color_15
        color_16 = colors.color_16
        color_17 = colors.color_17
        color_18 = colors.color_18
        color_19 = colors.color_19
        color_20 = colors.color_20
        color_21 = colors.color_21
        color_22 = colors.color_22
        color_23 = colors.color_23
        color_24 = colors.color_24
        color_25 = colors.color_25
        colorOther_1 = colors.colorOther_1
        colorOther_2 = colors.colorOther_2
        colorOther_3 = colors.colorOther_3
        colorOther_4 = colors.colorOther_4
        colorOther_5 = colors.colorOther_5
        colorOther_6 = colors.colorOther_6
        colorOther_7 = colors.colorOther_7
        colorOther_8 = colors.colorOther_8
        error = colors.error
        transparent = colors.transparent
        color_3_50 = colors.color_3_50
        color_3_80 = colors.color_3_80
    }
}

@Composable
internal fun ProviderUiKitColors(colors: UiKitColors, content: @Composable () -> Unit) {
    val colorPalette = remember { colors }
    colorPalette.update(colors)
    CompositionLocalProvider(LocalUiKitColors provides colorPalette, content = content)
}

internal val LocalUiKitColors =
    staticCompositionLocalOf<UiKitColors> { error("Colors not provided!!!") }

val md_theme_light_primary = Color(0xFF006491)
val md_theme_light_onPrimary = Color(0xFFFFFFFF)
val md_theme_light_secondary = Color(0xFF006590)
val md_theme_light_onSecondary = Color(0xFFFFFFFF)
val md_theme_light_error = Color(0xFFBA1A1A)
val md_theme_light_onError = Color(0xFFFFFFFF)
val md_theme_light_background = Color(0xFFFCFCFF)
val md_theme_light_onBackground = Color(0xFF1A1C1E)
val md_theme_light_surface = Color(0xFFFCFCFF)
val md_theme_light_onSurface = Color(0xFF1A1C1E)

val md_theme_dark_primary = Color(0xFF8ACEFF)
val md_theme_dark_onPrimary = Color(0xFF00344E)
val md_theme_dark_secondary = Color(0xFF89CEFF)
val md_theme_dark_onSecondary = Color(0xFF00344D)
val md_theme_dark_error = Color(0xFFFFB4AB)
val md_theme_dark_onError = Color(0xFF690005)
val md_theme_dark_background = Color(0xFF1A1C1E)
val md_theme_dark_onBackground = Color(0xFFE2E2E5)
val md_theme_dark_surface = Color(0xFF1A1C1E)
val md_theme_dark_onSurface = Color(0xFFE2E2E5)
